// extracted by mini-css-extract-plugin
export default {"root":"googleFontIcon_root__41zML","root--solid":"googleFontIcon_root--solid__63rvx","root--small":"googleFontIcon_root--small__zQbsW"};